module.exports = __webpack_public_path__ + "9291ee7097e50de3f43c0c30fbb8b7a1.svg";